import { getArticlesByNiche } from "./articles";

export interface InstitutionGuide {
  slug: string;
  label: string;
}

export const INSTITUTION_GUIDES: Record<string, InstitutionGuide> = {
  "Asaas Gestão Financeira": { slug: "desbloqueio-saldo-reserva-financeira-asaas", label: "Entenda as regras de desbloqueio no Asaas" },
  "Mercado Pago": { slug: "desbloqueio-saldo-mercado-pago", label: "Entenda as regras de desbloqueio no Mercado Pago" },
  PagBank: { slug: "desbloqueio-saldo-pagbank-pagseguro", label: "Entenda as regras de desbloqueio no PagBank" },
  "Stone/Ton": { slug: "desbloqueio-saldo-stone-ton", label: "Entenda as regras de desbloqueio na Stone" },
};

export function getInstitutionGuide(instituicao: string): { href: string; label: string } | null {
  const guide = INSTITUTION_GUIDES[instituicao];
  const article = guide && getArticlesByNiche("saldo-retido").find((a) => a.slug === guide.slug);
  return article ? { href: `/${article.niche}/${article.slug}`, label: guide.label } : null;
}
